<template>
  <BaseAction>
    <EditTalentPoolDialog @close="closeDialog" v-if="isOpen" />
    <SecondaryButton @click.native="openDialog" textColor="#0965dc">
      <v-icon class>mdi-pencil</v-icon>
      Edit Pool Name
    </SecondaryButton>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import EditTalentPoolDialog from "@/views/workers/TalentPools/dialogs/EditTalentPoolDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "EditTalentPoolAction",
  components: {
    SecondaryButton,
    EditTalentPoolDialog,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
